import { Component, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import Utils from '../../utility';
import { GlobalService } from '../../../services/global.service';
import { ModalService } from '../../../shared/modal/modal.service';
import { FormGroup, FormControl, Validators, FormArray, FormBuilder, ValidatorFn } from '@angular/forms';
import { DecimalPipe } from '@angular/common';
import { CommonModule, CurrencyPipe } from '@angular/common';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';

export interface reportData {
  fundingSource: string;
  annualContribution: number;
  startYear: number;
  endYear: number;
  inflationRate: number;
  totalContribution: number;
  action: string;
}

/* interface ValidatorFn {    
  (c: AbstractControl): ValidationErrors | null 
} */
const RangeValidator: ValidatorFn = (fg: FormGroup) => {
  const start = fg.get('startYear').value;
  const end = fg.get('endYear').value;
 return start !== null && end !== null && start <= end
   ? null 
   : { range: true };
};

@Component({
  selector: 'app-funding-source',
  templateUrl: './funding-source.component.html',
  styleUrls: ['./funding-source.component.css']
})
export class FundingSourceComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;  
  displayedColumns: string[] = ['fundingSource', 'annualContribution', 'startYear', 'endYear', 'inflationRate', 'totalContribution', 'action'];
  hcDataV2: any;
  view: any;
  modalName: string;
  public fundingItem: any;

  public client: any;
  public isMarried: boolean = false;
  public error: string;
  public LE;
  public totalRemainingGap: number = 0;
  public years;
  public year;
  public rate;
  public currentYear = new Date().getFullYear();

  fundingSourceForm: FormGroup;
  dataSource: any[] = [];//MatTableDataSource<reportData>;

  constructor(private formBuilder: FormBuilder, private globalService: GlobalService, private currencyPipe: CurrencyPipe,
    private decimalPipe: DecimalPipe, private modalService: ModalService, public dialogRef: MatDialogRef<FundingSourceComponent>,
    @Inject(MAT_DIALOG_DATA) data
  ) {
    //this.hcDataV2 = data.hcDataV2;
    //this.client = data.client;
    this.modalName = data.modalName;
    this.view = [innerWidth / 2.4, 400];

    this.rate = []
    for (var i = 0; i < 1 + 10; i++) {
      this.rate.push(i);
    }

    if(data.dataSource != ''){
      this.dataSource = data.dataSource;
      this.dataSource = [...this.dataSource];  //refresh the dataSource

      //need to reset what gets displayed first now
      this.addingFunds = false;
    }
  }

  createList(id: number): reportData {
    //TODO: this object needs to be able to set the selected report for this client
   return {
     fundingSource: 'Part-time job',
     annualContribution: 1000,
     startYear: 2023,
     endYear: 2056,
     inflationRate: 3.0,
     totalContribution: 1000,
     action: 'link to report'
   };
 }

  ngOnInit() {


    this.fundingSourceForm = this.formBuilder.group({
      fundingSource: ['', Validators.required],
      annualContribution: ['', Validators.required],
      inflationRate: ['3', [Validators.required, Validators.maxLength(3), Validators.max(10), Validators.min(0)]],
      //TODO: do we allow back in time stuff here?? Is max set too high?
      startYear: ['', [Validators.required, Validators.maxLength(4), Validators.max(3000), Validators.min(this.currentYear)]],
      endYear: ['', [Validators.required, Validators.maxLength(4), Validators.max(3000), Validators.min(this.currentYear)]]
    },
    { validators: RangeValidator});
    
    //do a check/listen here to make sure start is not after the end year
    this.fundingSourceForm.get("startYear").valueChanges.subscribe(value => {
      if(value > this.fundingSourceForm.value.endYear){
        //if in here, trigger validation, or reset?
        this.fundingSourceForm.updateValueAndValidity();
      }
    });
    this.fundingSourceForm.get("endYear").valueChanges.subscribe(value => {
      if(value < this.fundingSourceForm.value.startYear){
        //if in here, trigger validation, or reset?
        this.fundingSourceForm.updateValueAndValidity();
      }
    });

    this.getClient();

  }

  addFunding(){
    this.addingFunds = true;
  }

  getClient() {
    this.globalService.getClientData(Number(localStorage.getItem("selectedClient")), 4)
      .subscribe(
        client => {
          console.log('client', client);
          this.client = client;
          this.client.clientProfile.Spouses = JSON.parse(this.client.clientProfile.Spouses);
          this.isMarried = this.client.clientProfile.Spouses[0] && this.client.clientProfile.Spouses[0].maritalStatus == 'Married' ? true : false;
          this.LE = this.client.clientProfile.LifeExpectancy;
          this.endYearValidation();


          //this.getHCData();
        },
        error => this.error = <any>error);
  }
  endYearValidation() {
    let clientDOB = new Date(this.client.client.DOB);
    let clientDOBYear = clientDOB.getFullYear();
    let spouseDOB = this.client.clientProfile.Spouses[0].maritalStatus == 'Married' ? new Date(this.client.clientProfile.Spouses[0].dob): new Date();
    let spouseDOBYear = spouseDOB.getFullYear();
    console.log('spouseDOBYear', spouseDOBYear);
    console.log('spouseLE', this.client.clientProfile.Spouses[0].LifeExpectancy);
    console.log('this.client.clientProfile.Spouses[0].maritalStatus', this.client.clientProfile.Spouses[0].maritalStatus);
    console.log('this.LE', this.LE);
    console.log('clientDOBYear');

    let maxEndYear = this.client.clientProfile.Spouses[0].maritalStatus == 'Married' ? (Number(this.client.clientProfile.Spouses[0].LifeExpectancy || 0) > Number(this.LE || 0) ? Number(this.client.clientProfile.Spouses[0].LifeExpectancy) + Number(spouseDOBYear) : Number(this.LE) + Number(clientDOBYear)): Number(this.LE) + Number(clientDOBYear);
    console.log('maxEndYear', maxEndYear);
    this.fundingSourceForm.controls['startYear'].setValidators([Validators.required, Validators.min(this.currentYear), Validators.max(maxEndYear)]);
    this.fundingSourceForm.controls['endYear'].setValidators([Validators.required, Validators.min(this.fundingSourceForm.value.startYear? this.fundingSourceForm.value.startYear: this.currentYear), Validators.max(maxEndYear)]);

  }

  /* calculateAge(birthday) {
    birthday = new Date(birthday);
    var ageDifMs = Date.now() - birthday;
    var ageDate = new Date(ageDifMs);
    return Math.abs(ageDate.getUTCFullYear() - 1970);
  } */

 calculateAge(birthday) {
    var bday = new Date(birthday);
    var today = new Date();
    return today.getFullYear() - bday.getFullYear();
  }


  getHCData() {

    var HCReport = {  
    }

    var user = {
      UserID: Number(localStorage.getItem('roleId')) <= 2 ? localStorage.getItem('selectedAdvisorID') : localStorage.getItem('userId'),
      CompanyCode: Number(localStorage.getItem('roleId')) <= 2 ? localStorage.getItem('selectedAdvisorOrgID') : localStorage.getItem('orgID'),
      ClientID: localStorage.getItem('selectedClient')
    }

    this.globalService.getHCDataV2(HCReport, user)
      .subscribe(
        data => {
          this.hcDataV2 = data;

          this.totalRemainingGap = Number(this.hcDataV2.Illustrations[0].BeginningBalance);
          console.log("totalRemainingGap", this.totalRemainingGap);

        },
        error => this.error = <any>error);

  }

  formatNumber(amount) {
    return Math.round(amount);
  }

  formatCurrency(val) {
    return Utils.formatToCurrency(Utils.formatToNumber(val));
  }

  formatNumber3(val) {

    return Utils.formatToNumber(val);
  }

  indexOfEdit = 0;
  editMode: boolean = false;
  addingFunds: boolean = true;
  addFundingSource(): void {
    if(this.fundingSourceForm.invalid){
      return;
    }

    //save data
    if(!this.editMode){
      //just adding to list
      //this.dataSource = new MatTableDataSource(this.createList());
      this.dataSource.push({
        fundingSource: this.fundingSourceForm.value.fundingSource,
        annualContribution: this.fundingSourceForm.value.annualContribution,
        startYear: this.fundingSourceForm.value.startYear,
        endYear: this.fundingSourceForm.value.endYear,
        inflationRate: this.fundingSourceForm.value.inflationRate,
        //TODO: need to run calcs here for this value
        totalContribution: this.getFutureContributionAmountV2(this.fundingSourceForm.value.annualContribution, this.fundingSourceForm.value.startYear, (this.fundingSourceForm.value.endYear - this.fundingSourceForm.value.startYear), this.fundingSourceForm.value.inflationRate),
        action: 'link to report'
      });
    } else{
      //updating the list
      this.dataSource[this.indexOfEdit].fundingSource = this.fundingSourceForm.value.fundingSource;
      this.dataSource[this.indexOfEdit].annualContribution = this.fundingSourceForm.value.annualContribution;
      this.dataSource[this.indexOfEdit].startYear = this.fundingSourceForm.value.startYear;
      this.dataSource[this.indexOfEdit].endYear = this.fundingSourceForm.value.endYear;
      this.dataSource[this.indexOfEdit].inflationRate = this.fundingSourceForm.value.inflationRate;
      this.dataSource[this.indexOfEdit].totalContribution = this.getFutureContributionAmountV2(this.fundingSourceForm.value.annualContribution, this.fundingSourceForm.value.startYear, (this.fundingSourceForm.value.endYear - this.fundingSourceForm.value.startYear), this.fundingSourceForm.value.inflationRate);
      //this.dataSource[this.indexOfEdit].action = 'link to report'

      this.editMode = false;
      this.indexOfEdit = 0;
    }

    //refresh the dataSource
    this.dataSource = [...this.dataSource];

    //clear the form
    this.fundingSourceForm.reset();
    //but lets default the inflation again
    this.fundingSourceForm.patchValue({inflationRate:3});

    this.addingFunds = false;
  }

  removeFoundingSource(index: number){
    this.dataSource.splice(index, 1);

    //refresh the dataSource
    if(this.dataSource.length > 0){
      this.dataSource = [...this.dataSource];
    } else {
      //if stuff was added and then it was all removed, just close the modal
      this.dataSource = [];
      this.close(true);
    }
  }

  editFoundingSource(index: number){
    //TODO: what to do here...
    this.addingFunds = true; //swtich back to form
    this.editMode = true;
    this.indexOfEdit = index;
    //now pre-populate the form with the data from this line item to edit
    var indexData = this.dataSource[index];
    this.fundingSourceForm.patchValue({ fundingSource: indexData.fundingSource });
    this.fundingSourceForm.patchValue({ annualContribution: indexData.annualContribution });
    this.fundingSourceForm.patchValue({ inflationRate: indexData.inflationRate });
    this.fundingSourceForm.patchValue({ startYear: indexData.startYear });
    this.fundingSourceForm.patchValue({ endYear: indexData.endYear });

  }

  getFutureContributionAmountV2(startAmount, startYear, years, inflation) {
    var result = 0;
    var returnTotal = 0;
    var lastYearCost = 0;

    var birthday = new Date(this.client.client.DOB);
    var isDecBDay = (birthday.getMonth() == 11);
    var currentAge = this.calculateAge(this.client.client.DOB);
    var retirementAge = this.client.clientProfile.RetirementAge;
    //if(this.calculateAge(this.client.client.DOB) + i >= this.client.clientProfile.RetirementAge){
    //NOTE: IF statement needs to factor in earliest spouse for couples
    //var firstSpouseRetireYear = (this.isMarried) ? this.client.clientProfile.RetirementAge
    if(this.isMarried){
      //does spouse retire before client?
      var spouseCurrentAge = this.calculateAge(this.client.clientProfile.Spouses[0].dob);
      var spouseRetirementAge = this.client.clientProfile.Spouses[0].retirementAge;
      if(spouseRetirementAge - spouseCurrentAge < retirementAge - currentAge){
        //if in here, reset values above based on spouse
        currentAge = spouseCurrentAge;
        retirementAge = spouseRetirementAge;

        birthday = new Date(this.client.clientProfile.Spouses[0].dob);
        isDecBDay = (birthday.getMonth() == 11);
      }
    }

    var firstRetireYear = Math.min((retirementAge - currentAge), startYear - this.currentYear);

    for (let i = 0; i < years + 1; i++) {
      result = result + (startAmount * Math.pow((1 + inflation / 100), i));
      lastYearCost = (startAmount * Math.pow((1 + inflation / 100), i)); 
     
      //if(i >= (retirementAge - currentAge) - ((isDecBDay) ? 2 : 0)){
      //if(i >= (retirementAge - currentAge) - (startYear - this.currentYear)){
      if(i >= firstRetireYear - (startYear - this.currentYear)){
        console.log('entered IF index', i);
        returnTotal += lastYearCost;
      }
    }

    return returnTotal;//result;
  }


  close(update): void {
    console.log('Funding data source', this.dataSource);
    if(update){
      //return the list of funding sources we added to the illustration for recalcs
      this.dialogRef.close(this.dataSource);
    }else{
      if(this.dataSource.length > 0){
        this.dialogRef.close(this.dataSource);
      } else{
        //If in here, that means nothing was ever added to the funding source
        this.dialogRef.close();
      }
    }
  }

  onlyNumberKey(event) {
    console.log('event', event);
    const pattern = /[0-9\+\-\ ]/;

    let inputChar = String.fromCharCode(event.charCode);
    if ((event.keyCode != 8 && !pattern.test(inputChar)) || event.keyCode == 45) {
      event.preventDefault();
    }
}
  pasteDate(event) {
    let pasteData = event.clipboardData.getData('text'); if(pasteData){pasteData.replace(/[^0-9]*/g,'');}
  }

}

